module.exports = __webpack_public_path__ + "img/taote.1e4d88ba.png";